import { Card, FormSection } from '@ksyos/design-system';
import { formatString } from '@common/utils/formatString';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import type { ICareProviderAddCarePathState } from '../../../interfaces/careProviderAddCarePathState';
import type { IOrganization } from '../../../interfaces/organization';
import { getDisplayName } from '../../../../../common/utils/getDisplayName';
import { createEnumeration } from '../../../../utils/enumeration';
import { KgbSuccessPage } from '../../../elements/KgbSuccessPage';

interface ISuccessAndSummaryProps {
    addCarePathState: ICareProviderAddCarePathState;
    organization: IOrganization;
}

export function SuccessAndSummary(props: ISuccessAndSummaryProps) {
    const translate = getSelectedLanguage();

    if (!props.addCarePathState.employment) {
        return null;
    }

    return (
        <KgbSuccessPage
            buttonText={translate.carePath.returnToPersonalSettings}
            linkTo={`/employments/${props.addCarePathState.employment.id}/personalSettings`}
            summaryCard={renderSummaryCard()}
            text={createText()}
            title={translate.organization.successful}
        />
    );

    function createText() {
        if (!props.addCarePathState.practitioner) {
            return '';
        }
        const practitionerName = getDisplayName(props.addCarePathState.practitioner, false, 'nameGivenNameFamily');
        const text = formatString(translate.carePath.practitionerCanNowUse, [
            practitionerName,
            props.organization?.name,
        ]);
        const enumeration = createEnumeration(
            (props.addCarePathState.serviceGroups ?? []).map((serviceGroup) => serviceGroup.name)
        );

        return `${text} ${enumeration}.`;
    }

    function renderSummaryCard() {
        const serviceNames = (props.addCarePathState.serviceGroups ?? []).map((serviceGroup) => serviceGroup.name);

        if (!serviceNames) {
            return;
        }

        return (
            <Card>
                <Card.Header title={translate.common.summary} />
                <Card.Body>
                    <FormSection>
                        <FormParagraphFormGroup label={translate.carePath.chosenCarePath}>
                            {props.addCarePathState.episodeCategory
                                ? translate.episodeCategoryEnum[props.addCarePathState.episodeCategory.name]
                                : '-'}
                        </FormParagraphFormGroup>
                        <FormParagraphFormGroup label={translate.carePath.chosenServices}>
                            {serviceNames.join(', ')}
                        </FormParagraphFormGroup>
                    </FormSection>
                    {renderRoles()}
                </Card.Body>
            </Card>
        );
    }

    function renderRoles() {
        return (props.addCarePathState.serviceGroups ?? []).map((serviceGroup) => {
            return (
                <FormSection
                    key={serviceGroup.id}
                    title={serviceGroup.name}
                >
                    <FormParagraphFormGroup label={translate.carePath.role}>
                        {serviceGroup.profile?.name || '-'}
                    </FormParagraphFormGroup>
                </FormSection>
            );
        });
    }
}
